// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.a3omnNx_j558kc {
  box-sizing: border-box;
  border: none;
  outline: none;
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  padding: 8px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  width: 100%;
  margin-bottom: var(--ds-space-0, 0);
}
input.a3omnNx_j558kc::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
input.a3omnNx_j558kc:read-only {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
input.a3omnNx_j558kc:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
input.a3omnNx_j558kc:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
input.w83KUgaZn1gpOZ {
  padding-left: var(--ds-space-400, 32px);
}
input.uyc43XRMK0CLLA {
  padding-right: var(--ds-space-400, 32px);
}
input.CnTZlKrUqfJz6J,
input.CnTZlKrUqfJz6J:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
input.bwrR4zD_pCssYy {
  background-color: transparent;
  box-shadow: none;
}
input.bwrR4zD_pCssYy:read-only {
  background-color: transparent;
  box-shadow: none;
}
input.bwrR4zD_pCssYy:hover {
  background-color: transparent;
  box-shadow: none;
}
input.bwrR4zD_pCssYy:focus {
  background-color: transparent;
  box-shadow: none;
}
input.Avax2gBpu__Ua2 {
  background-color: var(--ds-background-neutral, #091e420f);
  box-shadow: none;
}
input.Avax2gBpu__Ua2:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
}
input.Avax2gBpu__Ua2:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
input.nmQZ290z8SjrLu {
  height: 24px;
  padding: 4px;
  line-height: 24px;
}
input.a3omnNx_j558kc:disabled,
input._wdlNCqzXv8chN {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
input.bwrR4zD_pCssYy:disabled,
input.cqaiJcylrVgQd1._wdlNCqzXv8chN,
input.bwrR4zD_pCssYy:disabled:hover,
input.cqaiJcylrVgQd1._wdlNCqzXv8chN:hover,
input.bwrR4zD_pCssYy:disabled:active,
input.cqaiJcylrVgQd1._wdlNCqzXv8chN:active {
  background-color: var(--ds-UNSAFE-transparent, transparent);
  box-shadow: none;
  color: var(--ds-text-subtle, #44546f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.JmEmaTTZspoihN {
  margin-left: var(--ds-space-025, 2px);
  color: var(--ds-icon-accent-red, #e34935);
}
label.HJVcICB6yQQtZI {
  font-weight: 700;
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: flex;
  flex-flow: column;
}
label.HJVcICB6yQQtZI input {
  margin-top: var(--ds-space-025, 2px);
}
.GqrY4Oem05XRJq {
  display: flex;
  position: relative;
  align-items: center;
}
.yJA8qyQ9_l3XkE {
  position: absolute;
  left: var(--ds-space-075, 6px);
}
.h2cAq2GgYIaS31 {
  position: absolute;
  right: var(--ds-space-075, 6px);
}
`, ""]);
// Exports
var _1 = `a3omnNx_j558kc`;
export { _1 as "nch-textfield__input" };
var _2 = `w83KUgaZn1gpOZ`;
export { _2 as "nch-textfield__input--withIconBefore" };
var _3 = `uyc43XRMK0CLLA`;
export { _3 as "nch-textfield__input--withIconAfter" };
var _4 = `CnTZlKrUqfJz6J`;
export { _4 as "nch-textfield__input--invalid" };
var _5 = `bwrR4zD_pCssYy`;
export { _5 as "nch-textfield__input--subtle" };
var _6 = `Avax2gBpu__Ua2`;
export { _6 as "nch-textfield__input--borderless" };
var _7 = `nmQZ290z8SjrLu`;
export { _7 as "nch-textfield__input--compact" };
var _8 = `_wdlNCqzXv8chN`;
export { _8 as "nch-textfield__input--disabled" };
var _9 = `cqaiJcylrVgQd1`;
export { _9 as "nch-textfield__input--subtleinput" };
var _a = `JmEmaTTZspoihN`;
export { _a as "nch-textfield__requiredMarker" };
var _b = `HJVcICB6yQQtZI`;
export { _b as "nch-textfield__label" };
var _c = `GqrY4Oem05XRJq`;
export { _c as "nch-textfield__iconContainer" };
var _d = `yJA8qyQ9_l3XkE`;
export { _d as "nch-textfield__icon--before" };
var _e = `h2cAq2GgYIaS31`;
export { _e as "nch-textfield__icon--after" };
export default ___CSS_LOADER_EXPORT___;
